<template>
  <div class="dynamic-menu-wrapper">
    <div v-if="!isLoading" ref="menuRef" class="menu-measure" :class="{'menu-loaded': !isLoading}">
      <ul>
        <li
            v-for="item in computedMenuItems"
            :key="item.id"
            :class="{'active': item.active}"
        >
          <router-link
              :to="item.link"
              class="text-TTDrugs-regular-16"
              @click.native="handleClick(item)"
          >
            {{ item.text }}
          </router-link>
          <span v-if="debug" style="font-size: 12px; color: #666;">
            (slug: {{ item.slug }}, active: {{ item.active }})
          </span>
        </li>
      </ul>

      <div v-if="menuItems.length === 0 && !debug" class="empty-message">
        Меню пустое
      </div>
    </div>

    <div class="dynamic-menu" :class="{ 'is-loading': isLoading }">
      <div v-if="isLoading" class="menu-placeholder" :style="placeholderStyle"></div>
      <div v-else class="menu-content">
        <ul>
          <li
              v-for="item in computedMenuItems"
              :key="item.id"
              :class="{'active': item.active}"
          >
            <router-link
                :to="item.link"
                class="text-TTDrugs-regular-16"
                @click.native="handleClick(item)"
            >
              {{ item.text }}
            </router-link>
            <span v-if="debug" style="font-size: 12px; color: #666;">
              (slug: {{ item.slug }}, active: {{ item.active }})
            </span>
          </li>
        </ul>

        <div v-if="menuItems.length === 0 && !debug" class="empty-message">
          Меню пустое
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppDynamicMenu",
  props: {
    menuItems: {
      type: Array,
      required: true,
      default: () => []
    },
    currentSlug: {
      type: String,
      default: ''
    },
    debug: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      menuHeight: null
    };
  },

  computed: {
    computedMenuItems() {
      if (!this.menuItems || !Array.isArray(this.menuItems)) {
        console.warn('menuItems не является массивом:', this.menuItems);
        return [];
      }

      return this.menuItems.map(item => {
        const isActive = item.slug === this.currentSlug;
        return {
          ...item,
          active: isActive
        };
      });
    },

    placeholderStyle() {
      return {
        height: this.menuHeight ? `${this.menuHeight}px` : 'auto',
        minHeight: '200px'
      };
    }
  },

  watch: {
    menuItems: {
      handler() {
        this.$nextTick(() => {
          this.updateMenuHeight();
        });
      },
      deep: true
    },
    isLoading: {
      handler(newVal) {
        if (!newVal) {
          this.$nextTick(() => {
            this.updateMenuHeight();
          });
        }
      }
    }
  },

  mounted() {
    this.updateMenuHeight();
    window.addEventListener('resize', this.updateMenuHeight);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateMenuHeight);
  },

  methods: {
    handleClick(item) {
      this.$emit('menu-item-click', item);
    },

    updateMenuHeight() {
      if (this.$refs.menuRef && !this.isLoading) {
        const height = this.$refs.menuRef.offsetHeight;
        this.menuHeight = height;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.dynamic-menu-wrapper {
  position: relative;
}

.menu-measure {
  position: absolute;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  left: 0;
  top: 0;
  width: 100%;
  z-index: -1;

  &.menu-loaded {
    position: absolute;
  }
}

.dynamic-menu {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0;
  min-width: 250px;
  margin-right: 50px;
  max-width: 300px;
  transition: opacity 0.3s ease;
  position: relative;
  min-height: 200px;

  &.is-loading {
    border-color: #e0e0e0;
  }

  @media (max-width: 1087px) {
    border: none;
    border-radius: 0;
    min-width: 100%;
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 20px;
    background-color: transparent;
    min-height: auto;

    &.is-loading {
      border: none;
    }
  }
}

.menu-placeholder {
  width: 100%;
  background: #f5f5f5;
  border-radius: 8px;
  transition: height 0.3s ease;

  @media (max-width: 1087px) {
    border-radius: 0;
  }
}

.menu-content {
  width: 100%;
}

.empty-message {
  padding: 20px;
  text-align: center;
  color: #999;
  font-style: italic;
}

.dynamic-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  @media (max-width: 1087px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    padding-top: 50px;
    padding-right: 0;
  }

  @media (max-width: 650px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
}

.dynamic-menu li {
  border-bottom: 1px solid #ddd;

  @media (max-width: 1087px) {
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #fff;
  }
}

.dynamic-menu li:last-child {
  border-bottom: none;

  @media (max-width: 1087px) {
    border-bottom: 1px solid #ddd;
  }
}

.dynamic-menu li.active {
  background-color: #f0f0f0;
  position: relative;

  @media (max-width: 1087px) {
    background-color: #fff;
  }
}

.dynamic-menu li.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #39bf42;
  transition: background-color 0.3s ease;

  @media (max-width: 1087px) {
    left: auto;
    top: auto;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 4px;
  }
}

.dynamic-menu a {
  display: block;
  padding: 12px;
  text-decoration: none;
  color: black;
  transition: background-color 0.3s ease;

  @media (max-width: 1087px) {
    padding: 10px 15px;
    text-align: center;
  }
}

.dynamic-menu a:hover {
  background-color: #e0e0e0;
}
</style>